import ReactDocx from "./ProtectedRoute";

export default ReactDocx;
